var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup41999(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41999",
    "data-name": "Group 41999",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.33,
    height: 70.775,
    viewBox: "0 0 69.33 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41945",
    "data-name": "Group 41945",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41939",
    "data-name": "Group 41939",
    transform: "translate(0 60.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M208.089,22.617a2.389,2.389,0,1,1-2.388,2.388A2.391,2.391,0,0,1,208.089,22.617Zm0,2.971a.583.583,0,1,0-.582-.583A.583.583,0,0,0,208.089,25.588Z",
    transform: "translate(-205.701 -22.617)",
    fill: "#ff7b00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41940",
    "data-name": "Group 41940",
    transform: "translate(9.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M315.734,110.412a.9.9,0,0,1,.639.265l2.039,2.039a.9.9,0,0,1,0,1.277l-2.039,2.039a.9.9,0,0,1-1.277,0l-2.039-2.039a.9.9,0,0,1,0-1.277l2.039-2.039A.9.9,0,0,1,315.734,110.412Zm.762,2.942-.762-.762-.762.762.762.762Z",
    transform: "translate(-312.792 -110.412)",
    fill: "#c5c5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41941",
    "data-name": "Group 41941",
    transform: "translate(54.457 64.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M45.357,317.648a.9.9,0,0,1,.639.265l2.039,2.039a.9.9,0,0,1,0,1.277L46,323.268a.9.9,0,0,1-1.277,0l-2.039-2.039a.9.9,0,0,1,0-1.277l2.039-2.04A.9.9,0,0,1,45.357,317.648Zm.763,2.942-.762-.763-.762.763.762.762Z",
    transform: "translate(-42.415 -317.648)",
    fill: "#6583fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6974",
    "data-name": "Path 6974",
    d: "M20.15,132.239a1.5,1.5,0,0,0-1.5,1.5v1.5h-1.5a1.5,1.5,0,1,0,0,3h1.5v1.5a1.5,1.5,0,1,0,3,0v-1.5h1.5a1.5,1.5,0,1,0,0-3h-1.5v-1.5A1.5,1.5,0,0,0,20.15,132.239Z",
    transform: "translate(44.685 -124.313)",
    fill: "#ff7b00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "IT_CS",
    "data-name": "IT CS",
    transform: "translate(3.729 2.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41998",
    "data-name": "Group 41998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41991",
    "data-name": "Group 41991",
    transform: "translate(1.41 47.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M88.625,362.742H28.4v3.812a2.8,2.8,0,0,0,2.7,2.881H85.922a2.8,2.8,0,0,0,2.7-2.881Z",
    transform: "translate(-28.401 -362.742)",
    fill: "#9192ff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41997",
    "data-name": "Group 41997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M175.648,90.137a13.187,13.187,0,1,0-13.189-13.185A13.2,13.2,0,0,0,175.648,90.137Zm0-23.555a10.367,10.367,0,1,1-10.369,10.37A10.381,10.381,0,0,1,175.648,66.582Z",
    transform: "translate(-144.126 -54.772)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M77.408,17.384H70.465a2.87,2.87,0,0,0-2.541-1.541h-.582a17.964,17.964,0,0,0-1.55-3.736l.408-.41a2.866,2.866,0,0,0,0-4.057L63.153,4.585a2.872,2.872,0,0,0-4.054,0L58.685,5a17.876,17.876,0,0,0-3.736-1.549V2.867A2.871,2.871,0,0,0,52.082,0H47.764A2.871,2.871,0,0,0,44.9,2.867v.582A17.872,17.872,0,0,0,41.161,5l-.413-.413a2.873,2.873,0,0,0-4.055,0L33.646,7.636a2.866,2.866,0,0,0,0,4.056l.413.414a17.957,17.957,0,0,0-1.55,3.736h-.582a2.87,2.87,0,0,0-2.541,1.541H22.406A4.026,4.026,0,0,0,18.4,21.421v30.29a4.042,4.042,0,0,0,4.037,4.037H40.916l-1.977,4.21H37.424a3.991,3.991,0,0,0-3.986,3.986V66.6a1.327,1.327,0,0,0,1.327,1.327H65.081A1.327,1.327,0,0,0,66.408,66.6V63.944a3.991,3.991,0,0,0-3.986-3.986H60.906l-1.977-4.21H77.408a4.041,4.041,0,0,0,4.037-4.037V21.421a4.041,4.041,0,0,0-4.037-4.037Zm-45.7,1.327a.22.22,0,0,1,.214-.214h1.611a1.327,1.327,0,0,0,1.295-1.036,15.343,15.343,0,0,1,2.013-4.853,1.327,1.327,0,0,0-.182-1.645L35.516,9.815a.2.2,0,0,1-.06-.148.209.209,0,0,1,.064-.152l3.05-3.054a.22.22,0,0,1,.3,0L40.013,7.6a1.326,1.326,0,0,0,1.649.182,15.253,15.253,0,0,1,4.851-2.012A1.327,1.327,0,0,0,47.55,4.479V2.868a.217.217,0,0,1,.214-.214h4.318a.217.217,0,0,1,.214.214V4.479a1.327,1.327,0,0,0,1.036,1.295,15.255,15.255,0,0,1,4.851,2.012A1.327,1.327,0,0,0,59.832,7.6l1.142-1.142a.22.22,0,0,1,.3,0L64.33,9.519a.2.2,0,0,1,.06.148.21.21,0,0,1-.065.153l-1.138,1.142a1.327,1.327,0,0,0-.182,1.645,15.339,15.339,0,0,1,2.013,4.853A1.327,1.327,0,0,0,66.313,18.5h1.611a.22.22,0,0,1,.214.214v4.314a.22.22,0,0,1-.214.214H66.313a1.327,1.327,0,0,0-1.295,1.036,15.352,15.352,0,0,1-2.013,4.857,1.327,1.327,0,0,0,.183,1.647l1.138,1.138a.217.217,0,0,1,0,.306l-3.051,3.051a.22.22,0,0,1-.3,0l-1.142-1.142a1.326,1.326,0,0,0-1.649-.182,15.253,15.253,0,0,1-4.851,2.012A1.327,1.327,0,0,0,52.3,37.256v1.611a.217.217,0,0,1-.214.214H47.764a.217.217,0,0,1-.214-.214V37.256a1.327,1.327,0,0,0-1.036-1.295,15.255,15.255,0,0,1-4.851-2.012,1.327,1.327,0,0,0-1.649.182l-1.142,1.142a.219.219,0,0,1-.3,0l-3.05-3.05a.217.217,0,0,1,0-.306l1.138-1.138a1.327,1.327,0,0,0,.183-1.647,15.347,15.347,0,0,1-2.013-4.857,1.327,1.327,0,0,0-1.295-1.036H31.921a.22.22,0,0,1-.214-.214ZM63.754,63.944v1.329H36.091V63.944a1.334,1.334,0,0,1,1.333-1.333h25A1.334,1.334,0,0,1,63.754,63.944Zm-5.779-3.986h-16.1l1.977-4.21H56Zm19.433-6.864H22.438a1.385,1.385,0,0,1-1.383-1.384v-2.26H57.525a1.327,1.327,0,1,0,0-2.653H21.054V21.421a1.37,1.37,0,0,1,1.352-1.384h6.647v2.987a2.871,2.871,0,0,0,2.867,2.867H32.5a17.974,17.974,0,0,0,1.55,3.739l-.41.41a2.873,2.873,0,0,0,0,4.058l3.05,3.05a2.872,2.872,0,0,0,4.054,0l.413-.413A17.879,17.879,0,0,0,44.9,38.286v.582a2.871,2.871,0,0,0,2.867,2.868h4.318a2.871,2.871,0,0,0,2.867-2.868v-.582a17.872,17.872,0,0,0,3.736-1.549l.413.413a2.873,2.873,0,0,0,4.055,0L66.2,34.1a2.873,2.873,0,0,0,0-4.058l-.41-.41a17.975,17.975,0,0,0,1.55-3.739h.582a2.871,2.871,0,0,0,2.867-2.867V20.037h6.616a1.385,1.385,0,0,1,1.383,1.384V46.8H69.914a1.327,1.327,0,0,0,0,2.653h8.877v2.26a1.385,1.385,0,0,1-1.383,1.384Z",
    transform: "translate(-18.401 0)",
    fill: "#3335cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M351.408,352.742a1.41,1.41,0,0,0,0,2.82h0a1.41,1.41,0,1,0,0-2.82Z",
    transform: "translate(-306.127 -306.064)",
    fill: "#ff7b00"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup41999);
export default __webpack_public_path__ + "static/media/Group 41999.f4518a55fde6df50e0678aa759a32418.svg";
export { ForwardRef as ReactComponent };